/*
 * fn: parseCardId
 *
 * Breaks up a cardId into parts so they can be used for fetch calls
 *
 */
import { CARD_ID_DELIMITER, type CardIdType } from '@/defs/card'

export const parseCardId = (cardId: CardIdType) => {
  const [slug, set, collectorNumber] = cardId.split(CARD_ID_DELIMITER)
  return { collectorNumber, set, slug: slug || 'unknown-slug' }
}
